<template>
  <div>
    <slot v-if="initialized"></slot>
    <div :id="id" ref="map"></div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";

export default {
  name: "LeafletMap",
  props: {
    id: String,
    savePath: Array,
    viewRoute: Array
  },
  components: {},
  mixins: [],
  data() {
    return {
      initialized: false,
      map: null,
      mapRoutingControl: null
    };
  },
  provide() {
    return {
      getMap: () => this.map
    };
  },
  mounted() {
    this.createMap();
  },
  methods: {
    createMap() {
      this.map = L.map(this.id);
      this.map.scrollWheelZoom.disable();
      //   this.map.locate({ watch: true });
      this.map.locate({ setView: true });
      this.map.on("focus", () => {
        this.map.scrollWheelZoom.enable();
      });
      this.map.on("blur", () => {
        this.map.scrollWheelZoom.disable();
      });
      // this.map.locate({ setView: true, maxZoom: 16 });
      const tiles = L.tileLayer(
        "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
        {
          maxZoom: 19,
          attribution:
            '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }
      ).addTo(this.map);

      this.map.on("load", () => {
        this.initialized = true;
        this.$emit("onInitialized");
      });
      this.map.on("contextmenu", e => {
        this.$emit("rightclick", e);
      });
    },
    fitBounds(boundsArray) {
      this.map.fitBounds(boundsArray);
    },
    getMarkersLatLng() {}
  }
};
</script>

<style scoped>
.leaflet-container {
  height: 400px;
  width: 600px;
  max-width: 100%;
  max-height: 100%;
}
</style>
